import React from 'react'
import { IntlProvider } from 'react-intl'

import Layout from './layout'

import messages from '../../locale/en'
import 'intl/locale-data/jsonp/en'


const LayoutEN = ({ baseUrl="/", children }) => <IntlProvider locale="en" messages={messages}>
  <Layout baseUrl={baseUrl}>
    {children}
  </Layout>
</IntlProvider>

export default LayoutEN
